import { makeStyles, TextField } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ToleranceIndicator from '../../QualityCheck/Creation/ToleranceIndicator';
import { dataService } from '../../../Services/data.service'
import { toast } from 'react-toastify';
//import appSettings from '../../../appsettings.json';
//import { HubConnectionBuilder } from '@microsoft/signalr';
import { uomM, uomMm, dimensionQualityChecks } from '../../../Config/constants';

export default function ToleranceQualityCheck(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [scaleData, setScaleData] = useState(null);
   // const [scaleConnection, setScaleConnection] = useState(null);

    useEffect(() => {
        dataService.GetLastWeight().then(data => {
            if (JSON.stringify(data) !== JSON.stringify(scaleData)) {
                setScaleData(data);
                props.measuredWeightChanged(data.weightInKg);
            }
        }).catch((error) => {
             toast.error(error, { position: toast.POSITION.TOP_CENTER });
            })
    }, [])

    // useEffect(() => {
    //     const newScaleConnection = new HubConnectionBuilder()
    //         .withUrl(appSettings.IPB_INTERFACE_SCALE_HUB_URL)
    //         .withAutomaticReconnect()
    //         .build();
    //     setScaleConnection(newScaleConnection);
    // }, []);

    // useEffect(() => {
    //     if (scaleConnection) {
    //         scaleConnection.start()
    //             .then(_ => {
    //                 console.log('Scale connected!');

    //                 scaleConnection.on('ReceiveData', scaleData => {
    //                     console.log("From scale hub: ")
    //                     console.log(scaleData);
    //                     setScaleData(scaleData);
    //                     props.measuredWeightChanged(scaleData.weightInKg)

    //                 });
    //             })
    //             .catch(e => console.log('Scale connection failed: ', e));
    //     }

    // }, [scaleConnection]);
    var emptyFieldCodes = props.emptyFieldCodes;
    let uom = "";
    switch (props.qualityCheck.uom) {
        case uomM:
            uom = 'm'
            break;
        case uomMm:
            uom = 'mm'
            break;
        default:
            uom = props.qualityCheck.uom
    }


    if (props.qualityCheck.description === dimensionQualityChecks.LENGTEL) {
        props.setLengteUom(props.qualityCheck.uom)
    }
    if (props.qualityCheck.description === dimensionQualityChecks.LENGTER) {
        uom = props.lengteUom
    }
    if (props.qualityCheck.description === dimensionQualityChecks.BREEDTE) {
        props.setBreedteUom(props.qualityCheck.uom)
    }

    if (props.qualityCheck.description === dimensionQualityChecks.GEWICHT) {
        uom = 'g/m²'
    }

    const changeWidth = (event) => {
        props.setPlateWidth(event.target.value)
    }

    const changeLength = (event) => {
        props.setPlateLength(event.target.value)
    }   

    return (
        <div className={classes.qualityCheck}>
            <div className={classes.qualityCheckContainer}>
                <div className={classes.qualityCheckName}>
                    {props.qualityCheck.description}{uom !== 'NULL' ? " (" : ""}{uom !== 'NULL' ? uom : ''}{uom !== 'NULL' ? ")" : ""}
                </div>
                <div className={classes.question}>
                    {props.qualityCheck.question}
                </div>
                <div className={classes.qualityCheckValue}>{
                    props.qualityCheck.description.includes(dimensionQualityChecks.GEWICHT) ?
                        <TextField value={props.calculatedWeight} id="outlined-search" label="" type="number" variant="outlined" className={classes.qualityCheckTextField} error={props.emptyFieldCodes.includes(props.qualityCheck.code)} size="small" onChange={(e) => props.qualityCheckChanged(e, props.qualityCheck.code)} />
                        :
                        <TextField id="outlined-search" label="" type="number" variant="outlined" className={classes.qualityCheckTextField } error={props.emptyFieldCodes.includes(props.qualityCheck.code)} size="small" onChange={(e) => props.qualityCheckChanged(e, props.qualityCheck.code)} />

                }
                </div>

            </div>
            <div className={classes.toleranceContainer}>
                {props.qualityCheck.toleranceMin !== null && props.qualityCheck.toleranceMax !== null ?
                    <ToleranceIndicator toleranceFactor={props.toleranceFactor} qualityCheck={props.qualityCheck}></ToleranceIndicator>
                    :
                    <React.Fragment></React.Fragment>}
            </div>
            {props.qualityCheck.description.includes(dimensionQualityChecks.GEWICHT) && scaleData ?
                <div className={classes.measuredWeightContainer}>
                    <div className={classes.scaleTitles}>
                        <div className={classes.length}>{t("Length") + " (" + props.lengteUom + ")"}</div>
                        <div className={classes.width}>{t("Width") + " (" + props.breedteUom + ")"}</div>

                        <div className={classes.scaleTitle}>
                            {t("Measured weight (kg)")}
                        </div>

                    </div>
                    <div className={classes.scaleTextFields} >
                        <TextField value={props.plateLength} className={classes.dimensionTextField} id="outlined-search" type="number" variant="outlined" size="small" onChange={(e) => changeLength(e)}></TextField>
                       
                        <TextField value={props.plateWidth} className={classes.dimensionTextField} id="outlined-search" type="number" variant="outlined" size="small" onChange={(e) => changeWidth(e)} ></TextField>
                        {/* <TextField id="outlined-search" label="" style={{ border: scaleData.weightInKg ? "" : "1px solid orange" }} type="number"  defaultValue = {scaleData.weightInKg ? scaleData.weightInKg : null} variant="outlined" className={classes.scaleTextField} size="small" onChange={(e) => props.measuredWeightChanged(e.target.value)} /> */}

                        <TextField disabled = {true} id="outlined-search" label="" style={{ border: scaleData.weightInKg ? "" : "1px solid orange" }} type="number" value={scaleData.weightInKg ? scaleData.weightInKg : null} variant="outlined" className={classes.scaleTextField} size="small" onChange={(e) => props.measuredWeightChanged(e.target.value)} />
                        <button className={classes.calculatorButton} onClick={() => props.calculateWeightPerSquareM()}>
                            <img className={classes.calculator} alt="planned" src={process.env.PUBLIC_URL + '/img/calculator.png'}></img>
                        </button>
                    </div>
                    <div className={classes.scaleMessage}>
                        {scaleData.message}
                    </div>

                </div> : <React.Fragment></React.Fragment>}
        </div>
    )
}

const useStyles = makeStyles({
    qualityCheckTextField: {
       backgroundColor: "white",
        borderRadius: "4px",
        boxSizing: "border-box",
        width: "100%"
    },
    scaleTextField: {
        backgroundColor: "white",
        borderRadius: "4px",
        boxSizing: "border-box",
        width: "calc(50% - 43px)",

    },
    dimensionTextField: {
        backgroundColor: "white",
        width: "23%",
        borderRadius: "4px",
        marginRight: "2%"
    },
    calculatorButton: {
        width: "37px",
        border: "none",
        outline: "none",
        cursor: "pointer",
        boxSizing: "border-box",

    },
    calculator: {
        width: "37px",
        height: "37px",
        boxSizing: "border-box",

    },
    qualityCheckName: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        color: "#020100",
    },
    length: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        color: "#020100",
        width: "25%",
        float: "left",
    },
    width: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        color: "#020100",
        width: "25%",
        float: "left",
    },
    question: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        color: "#020100",
    },
    qualityCheckContainer: {
        width: "35%",
        float: "left",
        boxSizing: "border-box",
    },
    toleranceContainer: {
        width: "35%",
        float: "left",
        boxSizing: "border-box",
        paddingTop: "40px",
    },
    measuredWeightContainer: {
        width: "30%",
        float: "left",
        boxSizing: "border-box",
        paddingTop: "15px"
    },
    qualityCheck: {
        width: "100%",
        height: "auto",
        overflow: "auto",
        marginBottom: "10px"
    },
    scaleMessage: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        textAlign: "right",
        paddingRight: "43px"
    },
    scaleTextFields: {
        width: "100%"
    },
    scaleTitle: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        color: "#020100",
        float: "left",
        width: "50%"
    }
});